import React from "react"
import { Link } from "gatsby"

import "./layout.css"

const Layout = ({ rest }) => {
  return (
    <footer
      style={{
        height: "120px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "130px",

        backgroundColor: `rgba(
            ${rest.color[0]},
            ${rest.color[1]},
            ${rest.color[2]},
            0.2
          )`,
        color: `rgb(
            ${rest.color[0]},
            ${rest.color[1]},
            ${rest.color[2]}
          )`,
      }}
    >
      © {new Date().getFullYear()} by&nbsp;<Link to="/"> Mon.Rest</Link>
    </footer>
  )
}

export default Layout
